__turbopack_context__.v({
  "active": "searchResultsMenu-module-scss-module__yvv-Kq__active",
  "activeLink": "searchResultsMenu-module-scss-module__yvv-Kq__activeLink",
  "beta": "searchResultsMenu-module-scss-module__yvv-Kq__beta",
  "burgerButton": "searchResultsMenu-module-scss-module__yvv-Kq__burgerButton",
  "cfrVariant": "searchResultsMenu-module-scss-module__yvv-Kq__cfrVariant",
  "container": "searchResultsMenu-module-scss-module__yvv-Kq__container",
  "creditflowVariant": "searchResultsMenu-module-scss-module__yvv-Kq__creditflowVariant",
  "headerContainer": "searchResultsMenu-module-scss-module__yvv-Kq__headerContainer",
  "headerContent": "searchResultsMenu-module-scss-module__yvv-Kq__headerContent",
  "headerScroll": "searchResultsMenu-module-scss-module__yvv-Kq__headerScroll",
  "headerTopRow": "searchResultsMenu-module-scss-module__yvv-Kq__headerTopRow",
  "hideMarketDataBtnWithOpenedSearchMenu": "searchResultsMenu-module-scss-module__yvv-Kq__hideMarketDataBtnWithOpenedSearchMenu",
  "hideSearchOnMobileView": "searchResultsMenu-module-scss-module__yvv-Kq__hideSearchOnMobileView",
  "iconContainer": "searchResultsMenu-module-scss-module__yvv-Kq__iconContainer",
  "iconContainerPremiumization": "searchResultsMenu-module-scss-module__yvv-Kq__iconContainerPremiumization",
  "innerMenuWrapper": "searchResultsMenu-module-scss-module__yvv-Kq__innerMenuWrapper",
  "isSearchFetching": "searchResultsMenu-module-scss-module__yvv-Kq__isSearchFetching",
  "isSearchResultsOpen": "searchResultsMenu-module-scss-module__yvv-Kq__isSearchResultsOpen",
  "link": "searchResultsMenu-module-scss-module__yvv-Kq__link",
  "linksButtonsContainer": "searchResultsMenu-module-scss-module__yvv-Kq__linksButtonsContainer",
  "linksWrapper": "searchResultsMenu-module-scss-module__yvv-Kq__linksWrapper",
  "menuOpenedOnMobileView": "searchResultsMenu-module-scss-module__yvv-Kq__menuOpenedOnMobileView",
  "new": "searchResultsMenu-module-scss-module__yvv-Kq__new",
  "panelLink": "searchResultsMenu-module-scss-module__yvv-Kq__panelLink",
  "premiumizationLinksContainer": "searchResultsMenu-module-scss-module__yvv-Kq__premiumizationLinksContainer",
  "searchResultOpenedOnMobileView": "searchResultsMenu-module-scss-module__yvv-Kq__searchResultOpenedOnMobileView",
  "solutionsButton": "searchResultsMenu-module-scss-module__yvv-Kq__solutionsButton",
  "spinner": "searchResultsMenu-module-scss-module__yvv-Kq__spinner",
  "spinnerOverlay": "searchResultsMenu-module-scss-module__yvv-Kq__spinnerOverlay",
  "title": "searchResultsMenu-module-scss-module__yvv-Kq__title",
  "toolbarContainer": "searchResultsMenu-module-scss-module__yvv-Kq__toolbarContainer",
  "transparentBackground": "searchResultsMenu-module-scss-module__yvv-Kq__transparentBackground",
  "userProPlan": "searchResultsMenu-module-scss-module__yvv-Kq__userProPlan",
  "withoutLogin": "searchResultsMenu-module-scss-module__yvv-Kq__withoutLogin",
});
